import { render, staticRenderFns } from "./caso-extraordinario-resumen.vue?vue&type=template&id=247f0e56&"
import script from "./caso-extraordinario-resumen.vue?vue&type=script&lang=ts&"
export * from "./caso-extraordinario-resumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports